<template>
  <div
    v-if="field.readOnly"
    hidden
  ></div>
  <TextInput
    v-else-if="field.type === 'text'"
    v-model="fieldValue"
    :label="field.label"
    :error="errResponse"
    :html-id="htmlId"
    :disabled="field.disabled"
    :required="field.required"
  />
  <DateInput
    v-else-if="field.type === 'date'"
    v-model="fieldValue"
    :label="field.label"
    :error="errResponse"
    :html-id="htmlId"
  />
  <DatetimeInput
    v-else-if="field.type === 'datetime'"
    v-model="fieldValue"
    :label="field.label"
    :error="errResponse"
    :html-id="htmlId"
  />
  <SelectInput
    v-else-if="field.type === 'select'"
    v-model="fieldValue"
    :label="field.label"
    :options="field.options"
    :optionValue="field.optionValue"
    :optionName="field.optionName"
    :error="errResponse"
    :html-id="htmlId"
  />
  <NumberInput
    v-else-if="field.type === 'number'"
    :step="field.step"
    v-model="fieldValue"
    :label="field.label"
    :error="errResponse"
    :html-id="htmlId"
  />
  <CheckboxInput
    v-else-if="field.type === 'checkbox'"
    v-model="fieldValue"
    :label="field.label"
    :error="errResponse"
    :html-id="htmlId"
  />
  <FileInput
    v-else-if="field.type === 'file'"
    v-model="fieldValue"
    :label="field.label"
    :error="errResponse"
    :html-id="htmlId"
  />
  <TextAreaInput
    v-else-if="field.type === 'textarea'"
    v-model="fieldValue"
    :label="field.label"
    :error="errResponse"
    :html-id="htmlId"
  />
  <input
    v-else-if="field.type === 'hidden'"
    type="hidden"
    v-model="fieldValue"
  />
  <p v-else>No input control available for type "{{
    //@ts-ignore
    field.type
    }}"</p>
</template>

<script
  lang="ts"
  setup
>
import TextInput from "./TextInput.vue"
import DatetimeInput from "./DatetimeInput.vue"
import SelectInput from "./SelectInput.vue"
import NumberInput from "./NumberInput.vue"
import DateInput from "./DateInput.vue"
import CheckboxInput from "./CheckboxInput.vue"
import FileInput from "./FileInput.vue"
import TextAreaInput from "./TextAreaInput.vue"
import { computed } from "vue"

interface FieldConfig {
  label: string
  errResponse?: string[]
  readOnly?: boolean
}

interface TextConfig extends FieldConfig {
  type: 'text'
  disabled?: boolean
  required?: boolean
}

interface DateConfig extends FieldConfig {
  type: 'date'
}

interface DateTimeConfig extends FieldConfig {
  type: 'datetime'
}

interface SelectConfig extends FieldConfig {
  type: 'select'
  options: any[]
  optionValue: string
  optionName: string
}

interface NumberConfig extends FieldConfig {
  type: 'number'
  step?: string
}

interface CheckboxConfig extends FieldConfig {
  type: 'checkbox'
}

interface FileConfig extends FieldConfig {
  type: 'file'
}

interface TextAreaConfig extends FieldConfig {
  type: 'textarea'
}

interface HiddenConfig extends FieldConfig {
  type: 'hidden'
}

export type FormFieldConfig = TextConfig | NumberConfig | DateConfig | DateTimeConfig | SelectConfig | CheckboxConfig | FileConfig | TextAreaConfig | HiddenConfig

const props = defineProps<{
  field: FormFieldConfig
  errResponse: any
  modelValue: any
  context: any
}>()

const emit = defineEmits<{
  (e: "update:modelValue", value: any): void
}>()
const fieldValue = computed({
  get(): any {
    return props.modelValue
  },
  set(fieldValue: any) {
    emit("update:modelValue", fieldValue)
  }
})
const htmlId = computed(() => {
  if (props.context !== null && props.context !== undefined) {
    return `${props.context}-${props.field.label.replaceAll(" ", "-").toLowerCase()}`
  }
  return props.field.label.replaceAll(" ", "-").toLowerCase()
})
</script>